import { HttpClient, HttpContext, HttpHeaders  } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';
import { AppState } from '../store/app.state';
import { UserSession } from '../models/user-session.model';
import { OfflineStorageService } from './offline-storage.service';
import { BEARER_ONLY, BYPASS_HEAD } from '../interceptor/token.interceptor';
import { clearTokenCart } from '../store/actions/tokens.actions';
import { clearPassCart } from '../store/actions/passes.action';

const USER_SESSION = 'userSession';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  // Init with null to filter out the first value in a guard!
  isAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  timeoutInterval: any;

  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
    private offlineStorageService: OfflineStorageService
  ) { }

  logIn(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrlV1 + '/api/v1/auth/lovebus/login', JSON.stringify(item));
  }

  signUp(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrlV1 + '/api/v1/auth/lgu/register', JSON.stringify(item));
  }

  signUpV2(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrlV1 + '/api/v1/auth/lovebus/register', JSON.stringify(item));
  }

  confirmRegistration(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/auth/confirm-registration', JSON.stringify(item));
  }

  forgotPassword(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/auth/forgot-password', JSON.stringify(item));
  }

  forgotPasswordConfirm(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/auth/confirm-password', JSON.stringify(item));
  }

  resendconfirmation(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/auth/resend-confirmation', JSON.stringify(item));
  }

  socialLogin(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/v2/auth/social-login', JSON.stringify(item));
  }

  deviceLogin(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/api/auth/device-login', JSON.stringify(item));
  }

  updateEmail(item) : Observable<any> {
    return this.http.post<any>(environment.apiUrl + '/v2/account/white-label-update-email', JSON.stringify(item));
  }

  resendVerificationCode(item) : Observable<any> {
    return this.http.post<any>(environment.apiUrl + '/v2/account/white-label-resend-code', JSON.stringify(item));
  }
  
  confirmEmail(item) : Observable<any> {
    return this.http.post<any>(environment.apiUrl + '/v2/account/white-label-confirm-email', JSON.stringify(item));
  }

  socialLoginV2(token, type): Observable<any> {
    return this.http
      .get(environment.apiUrlV1 + `/api/v1/auth/lovebus/login/${type}?token=${token}`);
  }

  signUpWeb(item): Observable<any> {
    return this.http
      .post<any>(environment.apiUrlV1 + '/api/v1/auth/lovebus/web-register', item, { context: new HttpContext().set(BEARER_ONLY, true) });
  }

  formatUser(data: any, userData) {
    const expirationDate = new Date(
      new Date().getTime() + +data.ExpiresIn * 1000
    );
    // const expirationDate = new Date();
    // expirationDate.setHours( expirationDate.getHours() + 24 );

    const userSession = new UserSession(
      data.IdToken, // idToken
      data.AccessToken, // accessToken
      data.RefreshToken, // refreshToken
      expirationDate, // expirationDate,
      userData // userData
    );
    return userSession;
  }

  async setUserSession(userSession: UserSession) {
    this.offlineStorageService.setObject(USER_SESSION, userSession);
    this.runTimeoutInterval(userSession);
  }

  runTimeoutInterval(userSession: UserSession) {
    const todayDate = new Date().getTime();
    const expirationDate = userSession.expiration_date.getTime();
    const timeInterval = expirationDate - todayDate;
    console.log({timeInterval});
    this.timeoutInterval = setTimeout(() => {
      window.dispatchEvent(new CustomEvent('auth:timeout', { detail: true}));  
    }, timeInterval);
  }

  async getUserSession() {
    const userSessionLocal: any = await this.offlineStorageService.getObject(USER_SESSION);
    if (userSessionLocal) {
      const expirationDate = new Date(userSessionLocal.expirationDate);
      const userSession = new UserSession(
        userSessionLocal.idToken,
        userSessionLocal.accessToken,
        userSessionLocal.refreshToken,
        expirationDate,
        userSessionLocal.userData
      );
      this.runTimeoutInterval(userSession);
      return userSession;
    }
    return null;
  }


  async logout() {
    await this.offlineStorageService.removeItem(USER_SESSION);
    this.store.dispatch(clearTokenCart());
    this.store.dispatch(clearPassCart());
    if (this.timeoutInterval) {
      clearTimeout(this.timeoutInterval);
      this.timeoutInterval = null;
    }
  }
}
